import ManageWithdrawals from 'layouts/withdrawal/ManageWithdrawals';
import WithdrawalView from 'layouts/withdrawal/WithdrawalView';
import ProtectedRoute from "routes/protectedRoutes.js";

const withdrawalRoutes = [

    {
      route: "/withdrawal/list/:pageNo",
      key: "manage-withdrawals",
      component: <ProtectedRoute check="logout"><ManageWithdrawals /></ProtectedRoute>
    },
    {
      route: "/withdrawal/view/:id",
      key: "view-withdrawals",
      component: <ProtectedRoute check="logout"><WithdrawalView /></ProtectedRoute>
    },


  ];

export default withdrawalRoutes;
 